import { styled } from "styled-components";

export const NonPageContainer = styled.div`
  height: 700px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #e5e7eb;
  border-radius: 15px;
  margin: 10px 5px;
`;

export const NonPageTitle = styled.div`
  font-size: 32px;
  margin-bottom: 40px;
`;
